import * as noTokenRequests from "../../api/noTokenRequest";
import {SET, CLEAR} from "../reducers/session";
import {push} from "./message";
import Cookies from 'js-cookie';
import {EN} from '../../ui/constants';
import {FINISH_LOAD} from "../reducers/user";

export const clearSession = () => {
    Cookies.remove('session');
    return {type: CLEAR};
};

export const setSession = (body) => {
    Cookies.set('session', body.token);
    return {type: SET, payload: body.token};
};


const finishLoading = (user) => {
    return {type: FINISH_LOAD, payload: user};
};

export const registerUser = (email, password, source,receive_newsletter, receive_updates) => {
    return dispatch => {
        return noTokenRequests.register(email, password, source, receive_newsletter, receive_updates)
            .then(session => {
                dispatch(push(EN.message.register));
                dispatch(clearSession(null));
                return session;
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

export const loginUser = (email, password) => {
    return dispatch => {
        return noTokenRequests.login(email, password)
            .then(session => {
                dispatch(setSession(session));
                return session
            })
            .catch(error => {
                dispatch(clearSession(null));
                dispatch(push(error.message))
            })
    }
};
export const forgotPassword = (email) => {
    return dispatch => {
        return noTokenRequests.forgotPassword(email)
            .then(res => {
                dispatch(push(EN.message.forgot_password));
                return res
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

export const resetPassword = (token, password) => {
    return dispatch => {
        return noTokenRequests.setNewPassword(token, password)
            .then(res => {
                dispatch(push('Success'));
                return res
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

export const logout = () => {
    return dispatch => {
        dispatch(finishLoading(null));
        dispatch(clearSession(null))
    }
};

